import React from "react";
import "../../../assets/MB_UFGN_4/scss/modules/MB_UFGN_4.scss";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import Header from "../../Includes/Layouts/MB_UFGN_4/Header";
import FormMB_UFGN_4 from "../../Forms/FormMB_UFGN_4";
import Section1 from "../../Includes/Layouts/MB_UFGN_4/Section1";
import AccordSection from "../../Includes/Layouts/MB_UFGN_4/AccordSection";
import Footer from "../../Includes/Layouts/MB_UFGN_4/Footer";
import FbViewPixel from "../../../Utility/FbViewPixel";
const MB_UFGN_4 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="MB_UFGN_4" />
      <FbViewPixel />
      <div className="MB_UFGN_4">
        <Header />
        <FormMB_UFGN_4 />
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};
export default MB_UFGN_4;